class CardVariantOption extends HTMLElement {
  constructor() {
    super();
    this.productCard = this.closest('.card');
    this.variantId = this.productCard?.querySelector('.product-variant-id');
    this.variantSelector = this.querySelector('select');
    this.variantSavings = this.querySelector('.saving');
    this.price = this.productCard?.querySelectorAll('.price-item--sale .money');
    this.addtocart = this.productCard?.querySelectorAll('.quick-add__submit ');
    if (this.variantSelector) {
      this.variantSelector.addEventListener(
        'change',
        debounce(() => this.updateVariantDetails(), 300)
      );
    }
  }

  connectedCallback() {
    // Ensure prices and savings are set on page load
    if (this.variantSelector) {
      this.updateVariantDetails();
    }
  }

  updateVariantDetails() {
    if (!this.variantSelector || !this.variantId) return;

    const selectedOption = this.variantSelector.options[this.variantSelector.selectedIndex];
    console.log("selectedOption", selectedOption);
    if (selectedOption) {
      this.variantId.value = selectedOption.value;
      
      if (this.variantSavings) {
        this.variantSavings.innerHTML = `Your savings: ${selectedOption.dataset.savings || '0'}`;
      }

      if (this.price) {
        this.price.forEach((priceElement) => {
          priceElement.innerHTML = selectedOption.dataset.price || 'N/A';
        });
      }
      const savings = selectedOption.dataset.savings || '0';
      const price = selectedOption.dataset.price || 'N/A';
      const savingsValue = parseFloat(savings.replace('Rs.', '').trim());
      const priceValue = parseFloat(price.replace('Rs.', '').trim());

      const compareAtHTML = selectedOption.dataset.variantCompare;      
      const compareAtElement = this.productCard?.querySelector(
        '.card-wrapper .quick-add .price--on-sale .price__sale .price-item--regular .money'
      );
      
      if (compareAtElement && compareAtHTML) {
        compareAtElement.innerHTML = compareAtHTML;
      }
      console.log(selectedOption.dataset.price, selectedOption.dataset.savings);
    }
  }
}

customElements.define("card-variant-picker", CardVariantOption);

